"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_dom_1 = require("react-dom");
var App_1 = __importDefault(require("./App"));
var smoothscroll_polyfill_1 = __importDefault(require("smoothscroll-polyfill"));
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
smoothscroll_polyfill_1.default.polyfill();
(0, react_dom_1.render)((0, jsx_runtime_1.jsx)(App_1.default, {}), document.getElementById('root'));
